import React from 'react';

const PublicationStatusSection = ({ jobData, handleInputChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Publication Status</h3>
      
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Job Status
        </label>
        <select
          name="status"
          value={jobData.status}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="draft">Draft (not visible to candidates)</option>
          <option value="active">Active (accepting applications)</option>
        </select>
        <p className="text-sm text-muted-foreground mt-1">
          You can change this later from the job management page.
        </p>
      </div>
    </div>
  );
};

export default PublicationStatusSection;